import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  OverlayView,
} from "react-google-maps";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBolt } from "@fortawesome/free-solid-svg-icons";
import { scooterEnumToNumStatuses } from "../../../../../data/scooter-numeric-statuses";
import { labelItems, pausedColor } from "./map-filter-items";

// eslint-disable-next-line react/display-name
const MapMarker = React.memo((props) => {
  const { isSelected, item } = props;
  const [showInfo, setShowInfo] = useState(false);

  let styles = {
    boxShadow: "none",
    zIndex: 10
  };
  if (isSelected) {
    styles = {
      boxShadow: "0 0 25px 12px #008B00",
      zIndex: 1000
    };
  }
  const speed = props.getSpeed(item.mileage);

  const statusLabelItem = labelItems.find(i => i.value === scooterEnumToNumStatuses[item.status]);
  const style = {
    backgroundColor: statusLabelItem ? statusLabelItem.color : "",
  };
  const speedMoreThen30 = speed >= 30 ? "speed-limit" : "";
  const isPaused = scooterEnumToNumStatuses.RIDING === scooterEnumToNumStatuses[item.status] && item.locked;
  if (isPaused) {
    style.backgroundColor = pausedColor;
  }

  return (
    <OverlayView
      position={{
        lat: item.located.latitude,
        lng: item.located.longitude
      }}
      mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
    >
      <div
        className="markerBikeBox"
        style={styles}
      >
        <div
          className={`markerBike ${speedMoreThen30} `}
          // onClick={() => props.showPositionFromMap(item)}
          onClick={() => setShowInfo(true)}
          style={style}
        >
          <div>{speed}</div>

          {item.charging && <FontAwesomeIcon
            icon={faBolt}
            className="position-absolute"
            style={{
              top: -8,
              right: 0,
              fontSize: 20,
              color: "blue"
            }}
          />}

          {item.batteryLvl && props.battery(item.batteryLvl)}

          {showInfo && (
            <div
              className="markerBikePopup"
              onClick={() => props.showPositionFromMap(item)}
              onMouseLeave={() => setShowInfo(false)}
            >
              <div>ID: {item.id}</div>
              <div>QR: {item.qr}</div>
              <div>
                <div>{props.progressBar(item.batteryLvl)}</div>
                <div className="d-flex justify-content-around">
                  <span>{props.onCharge({ charging: item.charging })}</span>
                  <span>{props.onGps(item.condition)}</span>
                  <span>{props.onLine({ online: item.connected.online })}</span>
                  <span>{props.onLock({ closed: item.locked })}</span>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

    </OverlayView>
  );
});

MapMarker.propTypes = {
  isSelected: PropTypes.bool.isRequired,
  item: PropTypes.object.isRequired
};

export default MapMarker;



// WEBPACK FOOTER //
// ./src/views/pages/scooter/scooter/hot-map/map-marker.js